import { EventEmitter } from 'events';
export const transactionEvents = new EventEmitter();
//# sourceMappingURL=transactionEvents.js.map